import React from 'react';

const LPFooter = () => {
  return (
    <footer className="bg-[#012169] text-white py-6 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left: Logo + Copyright */}
          <div className="flex items-center gap-3">
            <img 
              src="/logo-white-new.png" 
              alt="Crystal Trademark" 
              className="h-8 w-auto"
            />
            <span className="text-sm text-gray-400">
              © 2026 Crystal Trademark. All rights reserved.
            </span>
          </div>

          {/* Right: Legal Links */}
          <div className="flex items-center gap-4 text-sm">
            <a 
              href="/privacy" 
              className="text-gray-400 hover:text-[#F97316] transition-colors"
            >
              Privacy Policy
            </a>
            <span className="text-gray-600">|</span>
            <a 
              href="/terms" 
              className="text-gray-400 hover:text-[#F97316] transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LPFooter;
